export default "__VITE_ASSET__752bc67e__"